module.exports = __webpack_public_path__ + "projects.34d197ad.png";